/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { skippedCandidateDataReasonSchema } from './SkippedCandidateDataReasonSchema'

export const skippedCandidateDataSchema = z.object({
	candidateId: z.string(),
	reason: skippedCandidateDataReasonSchema,
})

export type SkippedCandidateDataSchema = z.infer<typeof skippedCandidateDataSchema>
